import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { Download, UploadFile } from '@mui/icons-material';
import { Alert, AlertTitle, Box, Button, Collapse, FormHelperText, Grid2, Link, Typography } from '@mui/material';
import Title from 'modules/Pricing/components/Title';
import ActionButtons from '../ActionButtons';

const ExcelForm = () => {
    const { t } = useTranslation();
    const translate = (key) => t(`price_group_wizard.excel_form.${key}`);
    const { handleBack } = usePriceGroup();

    const [openDetails, setOpenDetails] = useState(false);
    const steps = [translate('steps.step_1'), translate('steps.step_2'), translate('steps.step_3'), translate('steps.step_4')];
    const details = [translate('details.detail_1'), translate('details.detail_2'), translate('details.detail_3'), translate('details.detail_4'), translate('details.detail_5')];
    return (
        <Box component="section" sx={{ width: '100%', maxWidth: '480px' }}>
            <Title title={translate('title')} description={translate('description')} />

            <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" mt={2} gap="16px">
                <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start">
                    <Typography component="h6" fontSize={16} fontWeight={600} sx={{ color: '#131313' }}>
                        {translate('how_it_works')}
                    </Typography>
                    <Box component="ol" sx={{ pl: '2em', fontSize: 14, fontWeight: 500, color: '#131313', '& li': { pl: 0.5, mb: 0.5 } }}>
                        {steps.map((step) => (
                            <li key={step}>{step}</li>
                        ))}
                    </Box>
                </Grid2>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '4px' }}>
                    <Button
                        sx={{
                            border: '1px solid #13131340',
                            color: '#131313',
                            textTransform: 'none',
                            fontWeight: 700,
                            py: '8px',
                        }}
                        disabled
                        startIcon={<Download />}
                        variant="outlined"
                    >
                        {translate('download_button')}
                    </Button>
                    <FormHelperText>{translate('soon')}</FormHelperText>
                </Box>
                <Alert variant="outlined" severity="warning" sx={{ borderTop: 0, borderRight: 0, borderBottom: 0, borderRadius: 0, backgroundColor: '#ffa7240d', width: '100%' }}>
                    <AlertTitle sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '8px', marginTop: 0 }}>
                        <Typography fontSize="14px">{translate('alert.title')}</Typography>
                        <Link
                            sx={{
                                textTransform: 'none',
                                textDecoration: 'underline',
                                color: '#663c00',
                                fontSize: '14px',
                            }}
                            component="button"
                            variant="body2"
                            onClick={() => setOpenDetails(!openDetails)}
                        >
                            {openDetails ? translate('alert.hide') : translate('alert.show')}
                        </Link>
                    </AlertTitle>
                    <Collapse in={openDetails} timeout="auto" unmountOnExit>
                        <Box component="ol" sx={{ pl: '1em', fontSize: 14, fontWeight: 500, color: '#663c00', margin: 0, '& li': { pl: 0.5, mb: 0.5 } }}>
                            {details.map((detail) => (
                                <li key={detail}>{detail}</li>
                            ))}
                        </Box>
                    </Collapse>
                </Alert>
                <Button
                    sx={{
                        backgroundColor: 'var(--color-utriper-blue)',
                        width: '100%',
                        color: 'white',
                        textTransform: 'none',
                        fontWeight: 700,
                        py: '8px',
                    }}
                    disabled
                    startIcon={<UploadFile />}
                    variant="contained"
                >
                    {translate('submit_button')}
                </Button>
            </Grid2>

            <ActionButtons disabledNext handleBack={handleBack} />
        </Box>
    );
};

export default ExcelForm;
